import React, { useContext } from 'react';
import { OrderStatusContext } from '../../../context/OrderStatusContext';
import { ColorUtil } from '../../../util/color.util';
import { translate } from '../../../types/translation/Translator';
import { TranslationKey } from '../../../types/translation/TranslationKey';
import StatusLabel from '../../../VentoryUI/components/common/StatusLabel';

interface OrderStatusLabelProps {
  statusId: string;
}

export default function OrderStatusLabel({ statusId }: OrderStatusLabelProps) {
  const { orderStatuses } = useContext(OrderStatusContext);

  const status = orderStatuses.get(statusId);
  if (!status) return null;

  const text = translate({ key: (status.name.toLowerCase() || status) as TranslationKey });
  const color = { color: status.color, backgroundColor: ColorUtil.lightBackground(status.color) };

  return <StatusLabel color={color} text={text} />;
}
